var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 21h96V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.055 3.264h10.326L44 0H31.377c-2.433 0-4.29.63-5.522 1.87C24.624 3.11 23.999 4.982 24 7.432v6.139C24 18.5 26.482 21 31.378 21H44l-1.62-3.264H32.053c-1.387 0-2.434-.347-3.112-1.03-.679-.683-1.023-1.739-1.023-3.136V7.43c0-2.803 1.353-4.166 4.137-4.166",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    mask: "url(#b)",
    d: "M0 12h7V9H0zM11 12h7V9h-7zM0 3h18.38L20 0H0zM0 18v3h20l-1.62-3zM53.266 8.877V0H49v21h4.266v-8.867H58V8.877zM66.153 8.874H62v3.255h4.153V21L70 20.994V0h-3.847zM91.998 8.892h-4.724v3.252h4.724v1.425c0 2.805-1.383 4.168-4.228 4.168h-5.538c-2.845 0-4.228-1.363-4.228-4.167v-1.426h4.724V8.892h-4.724V7.43c.001-2.805 1.384-4.168 4.228-4.168h5.538c2.845 0 4.228 1.363 4.228 4.168v1.46zM88.461 0H81.54C76.536 0 74 2.5 74 7.43v6.14C74 18.5 76.536 21 81.539 21h6.922C93.464 21 96 18.5 96 13.57V7.43C96 2.5 93.464 0 88.461 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.d32e6788427442a51ee10584d3d52a40.svg";
export { ForwardRef as ReactComponent };